export const ANNOUNCEMENT_OPTIONS_TEXT = [
  "id",
  "title",
  "createdByUser",
  "singedBy",
  "Documents",
  "text",
];
